import React, { Component } from 'react';
import { strings } from '../../resources/strings';

const filenames = [
    "Horarios 2025 - Alcacer do Sal.pdf",
    "Horarios 2025 - Cercal - Milfontes.pdf",
    "Horarios 2025 - Grandola - Melides.pdf",
    "Horarios 2025 - Grandola - Carvalhal.pdf",
    "Horarios 2025 - Odemira - Milfontes.pdf",
    "Horarios 2025 - Odemira - Zambujeira.pdf",
    "Horarios 2025 - Santiago.pdf",
    "Horarios 2025 - Santo Andre.pdf",
    "Horarios 2025 - Sines.pdf"
];

export class SchedulesSummer extends Component {
    render() {
        return (
            <div className="schedules-container">
                <h2>{strings.schedulessummerInfo}</h2>
                <br />
                <p><b>{strings.schedulessummerInfoConditionA}</b></p>
                <br/>
                <div className="grid">
                    {filenames.map((filename) => {
                        const display = filename.replace(/\.pdf$/i, '').replace(/^Horarios 2025 - /, '');
                        const url = `docs/summer/${encodeURIComponent(filename)}`;
                        return (
                            <a key={filename} href={url} target="_blank" rel="noopener noreferrer">
                                {display}
                            </a>
                        );
                    })}
                </div>
            </div>
        );
    }
}
